<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-xl-6">
        <div v-for="(pillr, index) in pillars" :key="index" :class="['card','shadow',pillr]" style="overflow:auto;">
          <div class="card-body" style="min-width:700px;">
            <ul class="questions_tree mt-4">
              <tree-item
                v-if="renderCriteria"
                class="tree-item"
                :icon="pillarIcon(pillr)"
                :item="topicsTree[pillr]"
                :is-open-init="true"
                @criterionClicked="selectedPillar=pillr;fetchCriterionEvaluations($event, false);"
              ></tree-item>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-xl-6">
        <div id="results_scroll" class="d-xl-none"></div>
        <card v-if="selectedCriterionDto">
          <div class="mb-2" style="font-size: 25px;">{{ selectedCriterionDto.title }}</div>
          <table id="filters" class="" style="width:100%">
            <tbody>
              <tr>
                <td style="vertical-align:top;"><label>Year</label></td>
                <td>
                  <div class="form-group">
                    <select v-model="year" class="form-control" style="width:auto; height:35px; padding: 5px 10px 5px 10px;border-radius: 4px;border: 1px solid rgba(60,60,60,.26);" @change="fetchCriterionEvaluations(selectedCriterionDto, false)">
                      <option v-for="index in years" :key="index" :value="index">{{ index }}</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="vertical-align:top;"><label>Industry</label></td>
                <td>
                  <div class="form-group">
                    <v-select id="industry_filter" 
                              :class="{empty: showIndustryFilterPlaceholder}" 
                              v-model="industryIds" 
                              @input="fetchCriterionEvaluations(selectedCriterionDto, false)" 
                              :options="industriesFlat" multiple 
                              @open="isIndustryFilterFocused=true" 
                              @close="isIndustryFilterFocused=false"></v-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="vertical-align:top;"><label>Country</label></td>
                <td>
                  <div class="form-group">
                    <v-select id="country_filter" 
                              :class="{empty: showCountryFilterPlaceholder}" 
                              v-model="countryIds" 
                              @input="fetchCriterionEvaluations(selectedCriterionDto, false)" 
                              :options="countriesFlat" multiple 
                              @open="isCountryFilterFocused=true" 
                              @close="isCountryFilterFocused=false"></v-select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </card>
        <card v-if="loading || errorMessage !== ''" class="shadow">
          <div v-if="loading" class="text-warning">Loading, please wait...</div>
          <div v-if="errorMessage !== ''" class="text-danger">{{ errorMessage }}</div>
        </card>

        <card class="shadow">

          <div class="mb-3" style="position:relative;">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <span style="cursor:pointer;" :class="{'nav-link':true, 'active':activeDataset===2}" @click="activeDataset=2;">Industries</span>
              </li>
              <li class="nav-item">
                <span style="cursor:pointer;" :class="{'nav-link':true, 'active':activeDataset===1}" @click="activeDataset=1;">Broader Industries</span>
              </li>
            </ul>
            <div v-if="polarChartData || polarChartData2" style="position:absolute;right:5px;bottom:5px;"><a href="javascript:void(0);" @click="fetchCriterionEvaluations(selectedCriterionDto, true)"><span class="icomoon-cloud-download"></span>&nbsp;export&nbsp;as&nbsp;excel</a></div>
          </div>

          <div v-show="activeDataset===1">
            <div v-if="polarChartData">
              <div style="text-align:center;">
                <div class="text-warning">Broader Industries (NACE Codes)</div>
                <div v-if="isPolarDataNormalized" class="text-warning">(Projected in scale of ten)</div>
              </div>
              <div>
                <horizontal-bar-chart
                  :chart-data="polarChartData" 
                  :extra-options="polarChartOptions">
                </horizontal-bar-chart>
              </div>
            </div>
            <div v-if="industryEvaluations.length>0" class="table-responsive mt-4" style="overflow:auto;">
            <table class="table" style="width: 100%; min-width:700px;">
              <tbody>
                <tr v-for="(row, index) in industryEvaluations" :key="index">
                  <td class="industry_title">
                    <a :href="'/#/criteria?crit=' + selectedCriterionDto.id + '&year=' + year + '&industry=' + row.industryId" target="_blank">({{ row.industryNaceCode }})&nbsp;{{ row.industryTitle }}</a>
                  </td>
                  <td class="evaluation_answer">
                    <div v-if="selectedCriterionDto.isNumericIndex">
                      <div v-if="row.evaluationAnalystAnswerNumeric !== '' && row.evaluationAnalystAnswerNumeric !== null">{{ formatNumber(row.evaluationAnalystAnswerNumeric) }}</div>
                      <div v-else>N/A</div>
                    </div>
                    <div v-else>
                      <div v-if="row.evaluationAnalystAnswerText" v-html="row.evaluationAnalystAnswerText"></div>
                      <div v-else>N/A</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div v-if="!loading && industryEvaluations.length===0 && selectedCriterionDto">No results found for {{ year }}</div>
          </div>

          <div v-show="activeDataset===2">
            <div v-if="polarChartData2">
              <div style="text-align:center;">
                <div class="text-warning">Industries (NACE Codes)</div>
                <div v-if="isPolarDataNormalized2" class="text-warning">(Projected in scale of ten)</div>
              </div>
              <div>
                <horizontal-bar-chart
                  :chart-data="polarChartData2" 
                  :extra-options="polarChartOptions2">
                </horizontal-bar-chart>
              </div>
            </div>
            <div v-if="industryEvaluations2.length>0" class="table-responsive mt-4" style="overflow:auto;">
            <table class="table" style="width: 100%; min-width:700px;">
              <tbody>
                <tr v-for="(row, index) in industryEvaluations2" :key="index">
                  <td class="industry_title">
                    <a :href="'/#/criteria?crit=' + selectedCriterionDto.id + '&year=' + year + '&industry=' + row.industryId" target="_blank">({{ row.industryNaceCode }})&nbsp;{{ row.industryTitle }}</a>
                  </td>
                  <td class="evaluation_answer">
                    <div v-if="selectedCriterionDto.isNumericIndex">
                      <div v-if="row.evaluationAnalystAnswerNumeric !== '' && row.evaluationAnalystAnswerNumeric !== null">{{ formatNumber(row.evaluationAnalystAnswerNumeric) }}</div>
                      <div v-else>N/A</div>
                    </div>
                    <div v-else>
                      <div v-if="row.evaluationAnalystAnswerText" v-html="row.evaluationAnalystAnswerText"></div>
                      <div v-else>N/A</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div v-if="!loading && industryEvaluations2.length===0 && selectedCriterionDto">No results found for {{ year }}</div>
          </div>

        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
import TreeItem from "../components/TreeItem";
import vSelect from 'vue-select';
import HorizontalBarChart from "../components/Charts/HorizontalBarChart";
export default {
  name: "Insudtries",
  components: {
    TreeItem,
    HorizontalBarChart,
    vSelect
  },
  data () {
    return {
      loading: true,
      renderCriteria: false,
      errorMessage: '',
      topicsTree: {
        environmental: {
          title: 'Environmental Criteria',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'Social Criteria',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'Governance Criteria',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'Financial Criteria',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'General Criteria',
          id: null,
          childrenDtos: []
        },
      },

      activeDataset: 2,
      years: [],
      year: (this.$route.query.year !== '' && !isNaN(this.$route.query.year)) ? parseInt(this.$route.query.year) : ((new Date).getFullYear()-1),
      industryIds: [],
      countryIds: [],
      industryEvaluations: [],
      industryEvaluations2: [],
      selectedCriterionDto: null,
      selectedPillar: null,

      isPolarDataNormalized: false,
      isPolarDataNormalized2: false,
      polarChartData: null,
      polarChartData2: null,
      polarChartOptions: {
        legend: false,
        scales: {
          yAxes: [{ticks: {mirror: true, z: 1, padding: -5, fontColor: '#222222'}}]
        }, 
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (this.isPolarDataNormalized) {
                return this.formatNumber(this.industryEvaluations[tooltipItem.index].evaluationAnalystAnswerNumeric);
              } else {
                return this.formatNumber(tooltipItem.value);
              }
            }
          }
        }, 
        responsive: true,
        maintainAspectRatio: true,
      },
      polarChartOptions2: {
        legend: false, 
        scales: {
          yAxes: [{ticks: {mirror: true, z: 1, padding: -5, fontColor: '#222222'}}]
        }, 
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (this.isPolarDataNormalized2) {
                return this.formatNumber(this.industryEvaluations2[tooltipItem.index].evaluationAnalystAnswerNumeric);
              } else {
                return this.formatNumber(tooltipItem.value);
              }
            }
          }
        },
        responsive: true,
        maintainAspectRatio: true,
      },

      industriesFlat: [],
      industriesIndex: {},
      isIndustryFilterFocused: false,

      countriesFlat: [],
      countriesIndex: {},
      isCountryFilterFocused: false,

      frameworks: ['nza'],
      pillars: ['environmental']
    }
  },
  mounted () {
    this.fetchFrameworks();
    for (let i=2019; i<((new Date).getFullYear())+1; i++) {
      this.years.push(i);
    }
  },
  computed: {
    showIndustryFilterPlaceholder() {
      return this.industryIds.length === 0 && !this.isIndustryFilterFocused;
    },
    showCountryFilterPlaceholder() {
      return this.countryIds.length === 0 && !this.isCountryFilterFocused;
    }
  },
  methods: {
    fetchTopicsTree() {
      let self = this;
      Api.send('GET', '/prism/topics/all/tree?with_criteria=1&exclude_non_quantitative=1', {})
      .then((response) => {
        self.errorMessage = '';
        self.topicsTree.environmental.childrenDtos = response.environmental;
        self.topicsTree.social.childrenDtos = response.social;
        self.topicsTree.governance.childrenDtos = response.governance;
        self.topicsTree.financial.childrenDtos = response.financial;
        self.topicsTree.general.childrenDtos = response.general;
        self.renderCriteria = true;
        self.fetchCountries();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.topicsTree.environmental.childrenDtos = [];
        self.topicsTree.social.childrenDtos = [];
        self.topicsTree.governance.childrenDtos = [];
        self.topicsTree.financial.childrenDtos = [];
        self.topicsTree.general.childrenDtos = [];
        self.loading = false;
      });
    },
    fetchCountries() {
      let self = this;
      Api.send('GET', '/prism/countries', {})
      .then((response) => {
        self.errorMessage = '';
        response.map((countryDto) => {
          self.countriesFlat.push({
            code: countryDto.id,
            label: countryDto.title
          });
          self.countriesIndex[countryDto.id] = countryDto.title;
        });
        self.countryIds = (self.$route.query.country !== '' && !isNaN(self.$route.query.country)) ? [{code: parseInt(self.$route.query.country), label: self.countriesIndex[parseInt(self.$route.query.country)]}] : [];
        self.fetchIndustriesTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchIndustriesTree() {
      let self = this;
      Api.send('GET', '/prism/industries/all/tree', {})
      .then((response) => {
        self.registerIndustriesFlat(response);
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.industriesFlat = [];
      });
    },
    registerIndustriesFlat(industriesTree) {
      this.industriesFlat = [];
      for (let i in industriesTree) {
        this.registerIndustryChildren(industriesTree[i], '');
      }
      
      this.industryIds = (this.$route.query.industry !== '' && !isNaN(this.$route.query.industry)) ? [{code: parseInt(this.$route.query.industry), label: this.industriesIndex[parseInt(this.$route.query.industry)]}] : [];

      this.$nextTick(() => {
        let crit = null;
        if (this.$route.query.crit !== '' && !isNaN(this.$route.query.crit)) {
          crit = document.querySelector('#criterion_td_' + this.$route.query.crit);
        }
        if (!crit) {
          crit = document.querySelector('.criterion_td');
        }
        if (crit) {
          crit.click();
          let prnt = crit.parentNode;
          while (prnt) {
            let classList = prnt.classList;
            if (classList.length > 0) {
              if (classList[0] === 'questions_tree') {
                break;
              }
              if (classList[0] === 'tree-item') {
                let childNodes = prnt.childNodes;
                for(let i in childNodes) {
                  let classList2 = childNodes[i].classList;
                  if (classList2 && classList2.length > 0 && classList2[0] === 'table-responsive') {
                    prnt.firstChild.lastChild.click();
                  }
                }
              }
            }
            prnt = prnt.parentNode;   
          }
        }
      })
    },
    registerIndustryChildren(item, prefix) {
      let title = prefix;
      if (item.naceCode && item.naceCode !== '') {
        title += '(' + item.naceCode + ') ';
      }
      title += item.title;
      this.industriesFlat.push({
        code: item.id,
        label: title
      });
      this.industriesIndex[item.id] = title;
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerIndustryChildren(item.childrenDtos[i], prefix + '')
        }
      }
    },
    fetchCriterionEvaluations(criterionDto, asExcel) {
      if (!criterionDto || !criterionDto.id) {
        return false;
      }
      let self = this;
      self.selectedCriterionDto = criterionDto;

      let x = document.querySelectorAll(".criterion_td");
      let i;
      for (i = 0; i < x.length; i++) {
        x[i].classList.remove("selected");
      }
      document.getElementById('criterion_td_' + self.selectedCriterionDto.id).classList.add("selected");

      if (!asExcel) {
        let scrollElement = document.getElementById('results_scroll');
        if (scrollElement.offsetParent === null) {
          document.body.scrollIntoView();
        } else {
          scrollElement.scrollIntoView();
        }
      }

      let _industryIds = self.industryIds.map((x) => {
        return x.code;
      });
      let _countryIds = self.countryIds.map((x) => {
        return x.code;
      });
      let url = '/prism/criterion/' + self.selectedCriterionDto.id + '/industry_evaluations?year=' + self.year + '&industry=' + _industryIds.join('_') + '&country=' + _countryIds.join('_');
      if (asExcel) {
        let loggedUser = this.$root.getLoggedUser();
        location.replace(Api.getBaseUrl() + url + '&as_excel=1&bearer_token=' + loggedUser.token);
        return;
      }
      self.loading = true;
      Api.send('GET', url, {})
      .then((response) => {
        self.errorMessage = '';
        if (response.length) {
          let tmp1 = [];
          let tmp2 = [];
          for (let i in response) {
            if (response[i].industryParentId) {
              tmp2.push(response[i]);
            } else {
              tmp1.push(response[i]);
            }
          }
          if (self.selectedCriterionDto.isNumericIndex) {
            self.populatePolarChartData(tmp1, 1);
            self.populatePolarChartData(tmp2, 2);
          } else {
            self.polarChartData = null;
            self.polarChartData2 = null;
          }
          self.industryEvaluations = tmp1;
          self.industryEvaluations2 = tmp2;
        } else {
          self.polarChartData = null;
          self.polarChartData2 = null;
          self.industryEvaluations = [];
          self.industryEvaluations2 = [];
        }
        self.loading = false;
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.polarChartData = null;
        self.polarChartData2 = null;
        self.industryEvaluations = [];
        self.industryEvaluations2 = [];
        self.loading = false;
      });
    },
    formatNumber(number) {
      if (number > 1000000000000) {
        return (number/1000000000000).toFixed(2) + 'T'
      }

      if (number > 1000000000) {
        return (number/1000000000).toFixed(2) + 'B'
      }

      if (number > 1000000) {
        return (number/1000000).toFixed(2) + 'M'
      }

      if (number > 1000) {
        return (number/1000).toFixed(2) + 'K'
      }

      return parseFloat(number).toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
    },
    populatePolarChartData(response, datasetNumber) {
      let chartData = response.map(v => v.evaluationAnalystAnswerNumeric);
      let min = Math.min(...chartData);
      let max = Math.max(...chartData);
      if (max>100 && min/max < 0.01) {
        //Normalized data
        if (datasetNumber === 1) {
          this.isPolarDataNormalized = true;
        }
        if (datasetNumber === 2) {
          this.isPolarDataNormalized2 = true;
        }
        chartData = chartData.map((v) => {
          let nv = v/max*10;
          if (nv > 0.1) {
            nv = nv.toFixed(2);
          } else {
            if (nv > 0) {
              nv = 0.1;
            }
          }
          return nv;
        });
      } else {
        if (datasetNumber === 1) {
          this.isPolarDataNormalized = false;
        }
        if (datasetNumber === 2) {
          this.isPolarDataNormalized2 = false;
        }
      }

      let datasetObject = {data: chartData}
      switch (this.selectedPillar) {
        case 'environmental':
          datasetObject['backgroundColor'] = 'rgb(106 225 171 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(106 225 171 / 0.83)';
          break;
        case 'social':
          datasetObject['backgroundColor'] = 'rgb(255 197 91 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(255 197 91 / 0.83)';
          break;
        case 'governance':
          datasetObject['backgroundColor'] = 'rgb(158 158 255 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(158 158 255 / 0.83)';
          break;
        case 'financial':
          datasetObject['backgroundColor'] = 'rgb(255 158 158 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(255 158 158 / 0.83)';
          break;
      case 'general':
          datasetObject['backgroundColor'] = 'rgb(231 231 236 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(231 231 236 / 0.83)';
          break;
      }

      if (datasetNumber === 1) {
        this.polarChartData = {
          datasets: [datasetObject],
          labels: response.map(v => '(' + v.industryNaceCode + ') ' + v.industryTitle),
        };
      }
      if (datasetNumber === 2) {
        this.polarChartData2 = {
          datasets: [datasetObject],
          labels: response.map(v => '(' + v.industryNaceCode + ') ' + v.industryTitle),
        };
      }
    },
    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {})
      .then((response) => {
        self.frameworks = response;
        self.fetchPillars();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {})
      .then((response) => {
        self.pillars = response;
        self.fetchTopicsTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    pillarIcon(pillar) {
      switch(pillar) {
        case 'environmental':
          return 'icomoon-leaf';
        case 'social':
          return 'icomoon-man-woman';
          case 'governance':
          return 'icomoon-briefcase';
        case 'financial':
          return 'icomoon-coin-euro';
        case 'general':
          return 'icomoon-info';
        default:
          return 'icomoon-earth';
      }
    },
  }
};
</script>
<style scoped>
.questions_tree {
  padding-left: 0;
  line-height: 2em;
  list-style-type: none;
  font-size: 1.2em;
}
.card.environmental {
  border: 2px solid #2dce89;
  background-color: rgb(45 206 137 / 13%);
}
.card.social {
  border: 2px solid #ffd600;
  background-color: rgb(255 214 0 / 13%);
}
.card.governance {
  border: 2px solid #5e72e4;
  background-color: rgb(94 114 228 / 13%);
}
.card.financial {
  border: 2px solid #e45e5e;
  background-color: rgb(228 94 94 / 13%);
}
.card.general {
  border: 2px solid #a1a1a1;
  background-color: rgb(231, 231, 236);
}
.card .info-box {
  background-color: rgb(235, 235, 235);
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}
.info-box ul>li {
  color: inherit;
}
.height-50 {
  height: 50px;
  line-height: 50px;
  font-size: 50px;
}
td.industry_title {
  width: 30%;
}
td.evaluation_answer {
  width: 50%;
}
.nav-tabs .nav-item {
  margin-bottom: -0.1em;
  color: #525f7f;
}
.nav-tabs .nav-link.active {
  background-color: transparent;
  border-bottom: 1px solid #ffffff;
  color: #389466;
}
table#filters tbody tr td:first-child {
  width:100px !important;
}
#industry_filter.empty::before {
  content: 'All Industries';
  position: absolute;
  top: 5px;
  left: 10px;
}
#country_filter.empty::before {
  content: 'All Countries';
  position: absolute;
  top: 5px;
  left: 10px;
}
</style>
